import { SxProps, Theme } from "@mui/material";

/**
 * Base styling for search items (shared between Link and Button variants)
 */
export const getSearchItemBaseStyles = (isSelected: boolean, additionalSx?: SxProps<Theme>): SxProps<Theme> => ({
    display: "flex",
    alignItems: "center",
    px: { xs: 1, sm: 3 },
    py: 0.25,
    height: theme => ({ xs: theme.spacing(5), sm: theme.spacing(4.5) }),
    backgroundColor: isSelected ? "gray.50" : "transparent",
    "&:hover": {
        backgroundColor: "gray.50",
    },
    ...additionalSx,
});

export const getNavSearchItemStyles = (isSelected: boolean): SxProps<Theme> =>
    getSearchItemBaseStyles(isSelected, {
        px: { xs: 0, sm: 3 },
        height: theme => ({ xs: theme.spacing(5.25), sm: theme.spacing(4.5) }),
    });
